const Badges: React.FC = () => {
  return (
    <>
      <h1>
        Example heading <span className="badge bg-primary">New</span>
      </h1>
      <h2>
        Example heading <span className="badge bg-secondary">New</span>
      </h2>
      <h3>
        Example heading <span className="badge bg-success">New</span>
      </h3>
      <h4>
        Example heading <span className="badge bg-danger">New</span>
      </h4>
      <h5>
        Example heading <span className="badge bg-warning">New</span>
      </h5>
      <h6>
        Example heading <span className="badge bg-info">New</span>
      </h6>
      <h2 className="mt-5">Button badges</h2>
      <h3>Large button badges</h3>
      <div className="row mb-4">
        <div className="col mb-4 my-sm-0">
          <button type="button" className="btn btn-primary">
            Notifications <span className="badge bg-secondary">4</span>
          </button>
        </div>

        <div className="col mb-4 my-sm-0">
          <button type="button" className="btn btn-secondary">
            Notifications <span className="badge bg-primary">4</span>
          </button>
        </div>
      </div>
      <h3>Small button badges</h3>
      <div className="row">
        <div className="col mb-4 my-sm-0">
          <button type="button" className="btn btn-sm btn-primary">
            Notifications <span className="badge bg-secondary">4</span>
          </button>
        </div>

        <div className="col mb-4 my-sm-0">
          <button type="button" className="btn btn-sm btn-secondary">
            Notifications <span className="badge bg-primary">4</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Badges;
